import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const listeners = new Set();

// Revenue is hidden by default; the choice is kept per person and per screen on this device.
export function useRevenueVisible(screen) {
  const { user } = useAuth();
  const key = `revenueVisible:${user?.id || "anon"}:${screen}`;
  const [on, setOn] = useState(() => localStorage.getItem(key) === "1");
  useEffect(() => { setOn(localStorage.getItem(key) === "1"); }, [key]);
  const toggle = () => {
    const next = !on;
    localStorage.setItem(key, next ? "1" : "0");
    listeners.forEach((fn) => fn(key, next));
    setOn(next);
  };
  useEffect(() => { const fn = (k, v) => k === key && setOn(v); listeners.add(fn); return () => { listeners.delete(fn); }; }, [key]);
  return [on, toggle];
}

export function RevenueValue({ value, testid, screen }) {
  const [on, toggle] = useRevenueVisible(screen || testid);
  return (
    <span className="inline-flex items-center gap-2">
      <span data-testid={testid}>{on ? value : "••••"}</span>
      <button type="button" data-testid={`${testid}-eye`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(); }}
        title={on ? "Hide revenue" : "Show revenue"} className="text-slate-400 hover:text-slate-700">
        {on ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </span>
  );
}
